const data = {
  data: {
    Respuesta: [],
    // Respuesta: [''],
    blnError: false,
    codError: null,
    msgError: null
  }
}
  
export default data
